import React from "react";
import "../../Styles/yellowcalf.css/Reports.css";

function Reports() {
  return (
    <div className="reports-container" style={{paddingTop:"25px"}}>
      <div className="reports-grid">
        
        {/* Cashless Reports */}
        <div className="reports-card">
          <div className="reports-card-header">
            <h4>Cashless Reports</h4>
          </div>
          <div className="reports-card-body">
            <table className="reports-table">
              <tbody>
                <tr>
                  <td><i className="bi bi-wallet2"></i></td>
                  <td><a href="/accountant/wallet">Cashless Balance Report</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-cart-check"></i></td>
                  <td><a href="/accountant/wallet/walletsale">Wallet Sales Report</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-person-badge"></i></td>
                  <td><a href="/accountant/wallet/operatorsale">Wallet Sales Report (Operator)</a></td>
                </tr>  <tr>
                  <td><i className="bi bi-person-badge"></i></td>
                  <td><a href="/accountant/reports/expense/collection/">Fee Collection Report </a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Finance & Fee Reports */}
        <div className="reports-card">
          <div className="reports-card-header">
            <h4>Finance & Fee Reports</h4>
          </div>
          <div className="reports-card-body">
            <table className="reports-table">
              <tbody>
               
                <tr>
                  <td><i className="bi bi-clock-history"></i></td>
                  <td><a href="/WalletAGING">Aging Report (Overdue Fees)</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-people"></i></td>
                  <td><a href="/accountant/reports/siblings">Siblings Report</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-calendar3"></i></td>
                  <td><a href="/accountant/reports/balance">Terms/Semester Wise Balance New</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-star-fill"></i></td>
                  <td><a href="/accountant/reports/specialfee">Special Fee Report</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-credit-card-2-back"></i></td>
                  <td><a href="/accountant/reports/parentstransaction">Payment Mode Report</a></td>
                </tr><tr>
                  <td><i className="bi bi-credit-card-2-back"></i></td>
                  <td><a href="/accountant/reports/expense/feepaid">Yearly IncomeSummary Report </a></td>
                </tr>
                 <tr>
                  <td><i className="bi bi-box-seam"></i></td>
                  <td><a href="/accountant/reports/assets-register" >Assets Register Report New </a></td>
                </tr>
               
                <tr>
                  <td><i className="bi bi-person-lines-fill"></i></td>
                  <td><a href="/accountant/reports/student-statement">Student Payment Statement New</a></td>
                </tr>

                <tr>
                  <td><i className="bi bi-chat-left-dots"></i></td>
                  <td><a href="/accountant/reports/sms-delivery">SMS Delivery Report</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Accounting Reports (links to existing Finance pages - no extra page) */}
        <div className="reports-card">
          <div className="reports-card-header">
            <h4>Accounting Reports</h4>
          </div>
          <div className="reports-card-body">
            <table className="reports-table">
              <tbody>
                <tr>
                  <td><i className="bi bi-list-columns-reverse"></i></td>
                  <td><a href="/accountant/finance/trial-balance">Trial Balance</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-file-earmark-bar-graph"></i></td>
                  <td><a href="/accountant/finance/financial-statements">Financial Statements</a></td>
                </tr>
                <tr>
                  <td><i className="bi bi-check2-square"></i></td>
                  <td><a href="/accountant/finance/gl-tie-out">GL Tie-Out</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Reports;